import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-billing",
  "use": "icon-menu-billing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-billing\">\n    <rect x=\"5\" y=\"7\" width=\"14\" height=\"10\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n    <rect x=\"5.5\" y=\"10.5\" width=\"1\" height=\"13\" rx=\"0.5\" transform=\"rotate(-90 5.5 10.5)\" stroke=\"currentColor\" />\n    <rect x=\"13.5\" y=\"14.5\" width=\"1\" height=\"3\" rx=\"0.5\" transform=\"rotate(-90 13.5 14.5)\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol